module.exports = __webpack_public_path__ + "static/media/unavailable-icon.871004de.svg";